import { Link } from "react-router-dom";

function FeatureCard(props) {
  const data = props.data;
  const to = data.url
    ? `/${String(data.url).replace(/^\//, "")}`
    : "#";

  return (
    <article className="flex h-[280px] flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800 transition-shadow duration-200 hover:shadow-md">
      <Link to={to} className="block h-32 shrink-0 overflow-hidden">
        <img
          className="h-full w-full object-cover transition-transform duration-300 ease-out hover:scale-105"
          src={data.imgurl}
          alt={data.title}
        />
      </Link>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-4">
        <Link to={to} className="group mb-1 block min-w-0 shrink-0">
          <h3 className="truncate text-lg font-semibold tracking-tight text-gray-900 dark:text-white group-hover:text-sky-600 dark:group-hover:text-sky-400">
            {data.title}
          </h3>
        </Link>
        <p
          className="line-clamp-2 min-h-0 flex-1 overflow-hidden text-sm leading-relaxed text-gray-600 dark:text-gray-400"
          title={data.body}
        >
          {data.body}
        </p>
        <Link
          to={to}
          className="mt-2 inline-flex w-fit shrink-0 items-center gap-1.5 text-sm font-medium text-sky-600 hover:underline dark:text-sky-400"
        >
          Read more
          <svg
            className="h-3.5 w-3.5 shrink-0"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 5h12m0 0L9 1m4 4L9 9"
            />
          </svg>
        </Link>
      </div>
    </article>
  );
}

export default FeatureCard;
